import React, { Component } from "react";
import { Card } from "../../../components/Card/Card";
import "jqwidgets-scripts/jqwidgets/styles/jqx.base.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material-purple.css";
import "jqwidgets-scripts/jqwidgets/styles/jqx.material.css";
import { Grid, Col, Row } from "react-bootstrap";
import Loading from "../../../views/Loading";
import Swal from "sweetalert2"; // Asegúrate de tener esto instalado
import { dominio } from "../../../routes_backend/routes.jsx";


export class CalculoGranulometria extends Component {
  constructor(props) {
    super(props);
    this.state = {
      sourceGrid: "",
      message: "",
      isLoading: false,
    };
  }

  handlePesoRetenidoChange = () => {
    let suma = 0;
    for (let i = 0; i < 13; i++) {
      const input = document.getElementById(`pesoRetenido_${i}`);
      if (input && input.value !== "") {
        const valor = parseFloat(input.value);
        if (!isNaN(valor)) {
          suma += valor;
        }
      }
    }

    const sumaInput = document.getElementById("suma");
    if (sumaInput) {
      sumaInput.value = suma.toFixed(2);
    }

    this.calcularPesoAcumulado();
    this.calcularPorcentajeRetenido();
    this.calcularPorcentajeRetenidoAcumulado();
    this.calcularPorcentajePasa();
    this.moduloFinura();
  };

  calcularPesoAcumulado = () => {
    let acumulado = 0;
    for (let i = 0; i < 13; i++) {
      const input = document.getElementById(`pesoRetenido_${i}`);
      const inputAcumulado = document.getElementById(`pesoAcumulado_${i}`);
      if (input && inputAcumulado) {
        const valor = parseFloat(input.value);
        if (!isNaN(valor)) {
          acumulado += valor;
          inputAcumulado.value = acumulado.toFixed(2);
        } else {
          inputAcumulado.value = "";
        }
      }
    }
  };

  calcularPorcentajeRetenido = () => {
    const sumaInput = document.getElementById("suma");
    const suma = parseFloat(sumaInput?.value || "0");

    for (let i = 0; i < 13; i++) {
      const input = document.getElementById(`pesoRetenido_${i}`);
      const inputPorcentaje = document.getElementById(`porcentajeRetenido_${i}`);

      if (input && inputPorcentaje) {
        const valor = parseFloat(input.value);
        if (!isNaN(valor) && suma > 0) {
          inputPorcentaje.value = ((valor / suma) * 100).toFixed(2);
        } else {
          inputPorcentaje.value = "";
        }
      }
    }
  };

  calcularPorcentajeRetenidoAcumulado = () => {
    let acumulado = 0;
    for (let i = 0; i < 13; i++) {
      const inputPorcentaje = document.getElementById(`porcentajeRetenido_${i}`);
      const inputAcumulado = document.getElementById(`porcentajeAcumulado_${i}`);

      let valor = 0;
      if (inputPorcentaje && inputPorcentaje.value !== "") {
        valor = parseFloat(inputPorcentaje.value);
        if (isNaN(valor)) valor = 0;
      }

      acumulado += valor;

      if (inputAcumulado) {
        inputAcumulado.value = acumulado.toFixed(2);
      }
    }
  };

  calcularPorcentajePasa = () => {
    for (let i = 0; i < 13; i++) {
      const porcentajeRetenidoAcumulado = document.getElementById(`porcentajeAcumulado_${i}`);
      const porcentajePasa = document.getElementById(`porcentajePasa_${i}`);

      if (porcentajeRetenidoAcumulado && porcentajePasa) {
        const valor = parseFloat(porcentajeRetenidoAcumulado.value);
        if (!isNaN(valor)) {

          let res = valor / 100

          const resultado = 100 - (res);
          porcentajePasa.value = resultado.toFixed(2);
        } else {
          porcentajePasa.value = "";
        }
      }
    }
  };

  moduloFinura = () => {
    let sumaModuloFinura = 0;
    for (let i = 0; i <= 10; i++) {
      const porcentajeAcumulado = document.getElementById(`porcentajeAcumulado_${i}`);
      if (porcentajeAcumulado && porcentajeAcumulado.value !== "") {
        const valor = parseFloat(porcentajeAcumulado.value);
        if (!isNaN(valor)) {
          sumaModuloFinura += valor;
        }
      }
    }

    const moduloFinura = (sumaModuloFinura / 100).toFixed(2);
    const inputMF = document.getElementById("moduloFinura");
    if (inputMF) {
      inputMF.value = moduloFinura;
    }
  };

  handleEnviarDatos = async () => {
    const confirmacion = await Swal.fire({
      title: '¿Está seguro?',
      text: "Se enviarán los datos al servidor",
      icon: 'warning',
      showCancelButton: true,
      confirmButtonText: 'Sí, enviar',
      cancelButtonText: 'Cancelar'
    });

    if (!confirmacion.isConfirmed) return;

    this.setState({ isLoading: true });

    try {
      let username = "";
      let password = "";

      const token = localStorage.getItem("token");
      const token_Data = token ? JSON.parse(token) : null;

      if (Array.isArray(token_Data) && token_Data.length > 0) {
        const { usuarioSAP, contraseñaSAP } = token_Data[0];
        username = usuarioSAP;
        password = contraseñaSAP;
      } else {
        this.props.history.push("/login");
        return;
      }
      

      const tamices = [
        'M1_1_2', 'M1', 'M3_4', 'M1_2', 'M3_8',
        'No4', 'No8', 'No16', 'No30',
        'No50', 'No100', 'No200', 'Fondo'
      ];

      const filas = [
        { key: "pesoRetenido", nombreMedicion: "PESO RETENIDO (g)" },
        { key: "pesoAcumulado", nombreMedicion: "PESO RETENIDO ACUMULADO" },
        { key: "porcentajeRetenido", nombreMedicion: "% RETENIDO" },
        { key: "porcentajeAcumulado", nombreMedicion: "% RETENIDO ACUMULADO" },
        { key: "porcentajePasa", nombreMedicion: "% PASA" }
      ];

      const muestra = document.getElementById("muestra")?.value || "";
      const suma = document.getElementById("suma")?.value || "";
      const moduloFinura = document.getElementById("moduloFinura")?.value || "";
      const planta = document.getElementById("planta")?.value || "";
      const fecha = document.getElementById("fechaProduccion")?.value || "";
      const origen = document.getElementById("origen")?.value || "";
      const huboProduccion = document.getElementById("huboProduccion")?.checked ? "SI" : "NO";

      const datos = [];

      filas.forEach(fila => {
        const obj = {
          HUBO_PRODUCCION: huboProduccion,
          PLANTA: planta,
          FECHA: fecha,
          ORIGEN: origen,
          muestra: muestra,
          nombreMedicion: fila.nombreMedicion,
          SUMA: suma,
          "MODULO_DE_FINURA": moduloFinura
        };

        tamices.forEach((tamiz, idx) => {
          const valor = document.getElementById(`${fila.key}_${idx}`)?.value || "";
          obj[tamiz] = valor;
        });

        datos.push(obj);
        
        
        
      });

      console.log(datos);
      
      const response = await fetch(`${dominio}/registrarCalculoGrnm`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({ username, password, datos }),
      });
      

      const result = await response.json();

      if (!response.ok || !result.success) {
        const mensajeError = result.error || `Error del servidor: ${response.status}`;
        throw new Error(mensajeError);
      }

      Swal.fire({
        icon: 'success',
        title: '¡Enviado!',
        text: 'Los datos fueron enviados correctamente',
        timer: 2000,
        showConfirmButton: false
      }).then(() => {
        // refrescar la página al terminar los 2 segundos
        window.location.reload();
      });

    } catch (error) {
      console.error("Error al enviar:", error);
      Swal.fire({
        icon: 'error',
        title: 'Error',
        text: error.message || 'No se pudieron enviar los datos.',
      });
    } finally {
      this.setState({ isLoading: false });
    }
  };

  render() {
    return (
      <div className="content" style={{ textAlign: "center", alignItems: "center" }}>
        <Grid fluid>
          <Row>
            <Col md={12}>
              <Card
                title="Calclulo Granulometria"
                category=""
                ctTableFullWidth
                ctTableResponsive
                content={
                  <div className="content">
<div style={{ display: "flex", alignItems: "center", justifyContent: "center", flexWrap: "wrap", gap: 20, marginBottom: 20 }}>
    {/* PLANTA */}
  <div>
    <label style={styles.label}>PLANTA:</label>
    <select id="planta" style={styles.select}>
      <option value="">Seleccione</option>
      <option value="CKC K1">CKC K1</option>
      <option value="CKC K2">CKC K2</option>
      <option value="CKC K3">CKC K3</option>
      <option value="CKC K4">CKC K4</option>
      <option value="CKC K5">CKC K5</option>
      <option value="CKC K6">CKC K6</option>
      <option value="PVG">PVG</option>
      <option value="PVB">PVB</option>
      <option value="PVE">PVE</option>
      <option value="PVC">PVC</option>      
      <option value="PVX">PVX</option>
      <option value="PVR">PVR</option>
      <option value="PVH">PVH</option>
      <option value="PVP">PVP</option>
      <option value="PAE">PAE</option>
      <option value="PAX">PAX</option>
    </select>
  </div>
{/* FECHA */}
  <div>
    <label style={styles.label}>FECHA:</label>
    <input type="date" id="fechaProduccion" style={styles.select} />
  </div>




  {/* ORIGEN */}
  <div>
    <label style={styles.label}>ORIGEN:</label>
    <select id="origen" style={styles.select}>
      <option value="">Seleccione</option>
      <option value="PAE">PAE</option>
      <option value="PIEDRIN DEL SUR">PIEDRIN DEL SUR</option>
      <option value="TYRSA">TYRSA</option>
      <option value="MEDELLIN">MEDELLIN</option>
      <option value="PROSERCO">PROSERCO</option>
      <option value="SANTA ELENA">SANTA ELENA</option>
      <option value="SOL NACIENTE">SOL NACIENTE</option>
      <option value="TEODORO CHAY">TEODORO CHAY</option>
      <option value="AGRO NORTE">AGRO NORTE</option>
      <option value="CUCHUMATANES">CUCHUMATANES</option>
      <option value="AGREGA ESCUINTLA">AGREGA ESCUINTLA</option>
    </select>
  </div>

  {/* MUESTRA */}
  <div>
    <label style={styles.label}>MUESTRA:</label>
    <select id="muestra" style={styles.select}>
      <option value="">Seleccione</option>
      <option value="ARENA DE RIO">ARENA DE RIO</option>
      <option value="POLVO DE PIEDRA">POLVO DE PIEDRA</option>
      <option value="PIEDRIN 3/8">PIEDRIN 3/8</option>
      <option value="GRANZA FINA">GRANZA FINA</option>
      <option value="GRANZA RUSTICA">GRANZA RUSTICA</option>
      <option value="POLVO SELECTO">POLVO SELECTO</option>
      <option value="POLVO DE PIEDRA FINO">POLVO DE PIEDRA FINO</option>
      <option value="ARENA">ARENA</option>
    </select>
  </div>
  
<br />
<br />
{/* HUBO PRODUCCIÓN */}
<div style={{ display: "flex", alignItems: "center", gap: 5 }}>
  <label style={styles.label} htmlFor="huboProduccion">HUBO PRODUCCIÓN?</label>
  <input type="checkbox" id="huboProduccion" />
</div>
                      <table style={styles.table}>
                        <thead>
                          <tr>
                            <th style={styles.headerCell}></th>
                            {[
                              '1 1/2"', '1"', '3/4"', '1/2"', '3/8"',
                              'No. 4', 'No. 8', 'No. 16', 'No. 30',
                              'No. 50', 'No. 100', 'No. 200', 'Fondo'
                            ].map((tamiz, idx) => (
                              <th key={idx} style={styles.headerCell}>{tamiz}</th>
                            ))}
                            <th style={styles.headerCell}>SUMA</th>
                            <th style={styles.headerCell}>MODULO DE FINURA</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            { label: "PESO RETENIDO (g)", rowKey: "pesoRetenido" },
                            { label: "PESO RETENIDO ACUMULADO", rowKey: "pesoAcumulado" },
                            { label: "% RETENIDO", rowKey: "porcentajeRetenido" },
                            { label: "% RETENIDO ACUMULADO", rowKey: "porcentajeAcumulado" },
                            { label: "% PASA", rowKey: "porcentajePasa" },
                          ].map((row, rIdx) => (
                            <tr key={rIdx}>
                              <td style={styles.rowLabel}>{row.label}</td>
                              {Array.from({ length: 13 }).map((_, cIdx) => (
                                <td key={cIdx} style={styles.cell}>
                                  <input
                                    id={`${row.rowKey}_${cIdx}`}
                                    type="text"
                                    style={styles.input}
                                    onChange={
                                      row.rowKey === "pesoRetenido"
                                        ? this.handlePesoRetenidoChange
                                        : undefined
                                    }
                                  />
                                </td>
                              ))}
                              {row.rowKey === "pesoRetenido" ? (
                                <>
                                  <td style={styles.cell}>
                                    <input id="suma" type="text" style={styles.input} readOnly />
                                  </td>
                                  <td style={styles.cell}>
                                    <input id="moduloFinura" type="text" style={styles.input} readOnly />
                                  </td>
                                </>
                              ) : (
                                <>
                                  <td style={styles.cell}></td>
                                  <td style={styles.cell}></td>
                                </>
                              )}
                            </tr>
                          ))}
                        </tbody>
                      </table>
<br />
<br />
                    
                    </div>
                      {/* BOTÓN DE ENVÍO */}
                      <div style={{ marginTop: "20px" }}>
                        <button
                          onClick={this.handleEnviarDatos}
                          style={{
                            padding: "8px 20px",
                            backgroundColor: "#4CAF50",
                            color: "white",
                            border: "none",
                            borderRadius: "4px",
                            fontSize: "14px",
                            cursor: "pointer"
                          }}
                        >
                          Enviar Datos
                        </button>
                      </div>
                  </div>
                }
              />
            </Col>
          </Row>
        </Grid>
        {this.state.isLoading && <Loading />}
      </div>
    );
  }
}

export default CalculoGranulometria;

const styles = {
  label: {
    fontWeight: "bold",
    fontSize: "14px",
    marginRight: 10,
  },
  select: {
    padding: "5px",
    width: "200px",
    fontSize: "14px",
    border: "1px solid #aaa",
    borderRadius: "4px",
    textAlign: "center",
  },
  table: {
    borderCollapse: "collapse",
    marginTop: "10px",
    fontSize: "13px",
    minWidth: "80%",
    maxWidth: "95%",
  },
  headerCell: {
    backgroundColor: "#f0f0f0",
    border: "1px solid #bbb",
    padding: "6px 10px",
    textAlign: "center",
    fontWeight: "bold",
    fontSize: "12px",
  },
  rowLabel: {
    textAlign: "right",
    fontWeight: "bold",
    padding: "6px 10px",
    fontSize: "12px",
    border: "1px solid #ccc",
    backgroundColor: "#f9f9f9",
    whiteSpace: "nowrap"
  },
  cell: {
    border: "1px solid #ccc",
    padding: "4px",
  },
  input: {
    width: "60px",
    padding: "4px",
    fontSize: "12px",
    textAlign: "center",
    border: "1px solid #aaa",
    borderRadius: "3px",
  }
};
